import { render, staticRenderFns } from "./Kyoto.vue?vue&type=template&id=582c8958&"
import script from "./Kyoto.vue?vue&type=script&lang=js&"
export * from "./Kyoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports